const fbShare = document.querySelectorAll('.js-facebook');
const twShare = document.querySelectorAll('.js-twitter');

onClickShareFacebook = function(e){
  e.preventDefault();

  if (window.FB) {
    window.FB.ui({
      method: 'share',
      href: window.location.href,
    }, function(response){});
  }
}

if(fbShare) {
  fbShare.forEach(fb => fb.addEventListener('click', onClickShareFacebook))
}



// WEBPACK FOOTER //
// ./scripts/util/share.js